import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { isEmpty } from "lodash";
import TableContainer from "../../../../Components/Common/TableContainer";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteEmailAccount,
  deleteEmailAccountSuccess,
  getEmailAccountDetails,
  getEmailAccountList,
} from "../../../../store/CRMitEmailInbox/action";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import NoDataContent from "../../../../Components/Common/NoDataContent";
import CreateEditSettingsEmailAccount from "../../../../Components/popUpComponents/CreateEditSettingsEmailAccount";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { Tooltip } from "@mui/material";

export default function TabEmailAccounts() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const { emailAccountsListAPI, emailAccountsListLoading } = useSelector(
    (state) => ({
      emailAccountsListAPI:
        state.EmailInbound.emailAccountsList?.emailaccount_list,
      emailAccountsListLoading: state.EmailInbound.emailAccountsListLoading,
    })
  );

  useEffect(() => {
    dispatch(getEmailAccountList());
  }, []);
  const [copyToClipboard, setCopyToClipboard] = useState(null);
  useEffect(() => {
    const delay = setTimeout(() => {
      setCopyToClipboard(null);
    }, 1000);
    return () => {
      clearTimeout(delay);
    };
  }, [copyToClipboard]);
  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Nickname",
        accessor: "NickName",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.NickName}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Sender Name",
        accessor: "OutboundEmailFromBusinessName",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.OutboundEmailFromBusinessName}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Email Address",
        accessor: "InboundForwarder",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              {card.row.original?.InboundForwarder && (
                <div className="flex-grow-1 ms-2 name">
                  {card.row.original?.InboundForwarder}
                  <Tooltip
                    title="Click to copy enail address"
                    placement="top"
                    arrow
                  >
                    <span
                      onClick={() => {
                        navigator.clipboard.writeText(
                          card.row.original?.InboundForwarder
                        );
                        setCopyToClipboard(card.row.original?.InboundForwarder);
                      }}
                      className={
                        copyToClipboard === card.row.original?.InboundForwarder
                          ? "ms-1 text-success"
                          : "ms-1 text-muted cursor-pointer"
                      }
                    >
                      <i className="ms-1 fa-solid fa-copy"></i>
                      {copyToClipboard ===
                        card.row.original?.InboundForwarder && (
                        <span className={"fs-10 ms-2"}>Copied!</span>
                      )}
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
          </>
        ),
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                <li>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        handleCreateUpdateEmailAccount(
                          "update",
                          cellProps.row.original?.Id
                        );
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-pencil-fill align-center text-muted me-2"></i>
                        <span> Edit</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem>
                    <div
                      className="remove-item-btn"
                      onClick={() => {
                        setSelectToDelete([cellProps.row.original?.Id]);
                        setModalDeleteEmailAccount(true);
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-delete-bin-fill align-center text-muted me-2"></i>{" "}
                        <span> Delete</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    [copyToClipboard, searchResults]
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Nickname",
    "OutboundEmailFromBusinessName",
    "InboundForwarder",
  ]);
  useEffect(() => {
    let filteredCustomerList = emailAccountsListAPI;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key].toString().toLowerCase().includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, emailAccountsListAPI]);

  const [modalCreateEditEmailAccount, setModalCreateEditEmailAccount] =
    useState(false);
  const toggleCreateEditEmailAccount = () => {
    setModalCreateEditEmailAccount(!modalCreateEditEmailAccount);
  };
  const [isEdit, setIsEdit] = useState(false);
  const handleCreateUpdateEmailAccount = (type, id) => {
    if (type === "create") {
      setIsEdit(false);
      toggleCreateEditEmailAccount();
    }
    if (type === "update") {
      setIsEdit(true);
      toggleCreateEditEmailAccount();
      dispatch(getEmailAccountDetails({ id }));
    }
  };

  const { emailAccountsDetailsAPI } = useSelector((state) => ({
    emailAccountsDetailsAPI:
      state.EmailInbound.emailAccountsDetails?.emailaccount_data,
  }));
  const { emailAccountsDeleteAPI } = useSelector((state) => ({
    emailAccountsDeleteAPI: state.EmailInbound.emailAccountsDelete,
  }));
  const [selectToDelete, setSelectToDelete] = useState([]);

  const handleDeleteEmailAccount = () => {
    dispatch(deleteEmailAccount(selectToDelete));
  };
  //Delete Email Account response
  useEffect(() => {
    if (isEmpty(emailAccountsDeleteAPI)) return;
    if (emailAccountsDeleteAPI?.status === 200) {
      toast.success(emailAccountsDeleteAPI.message);
      dispatch(getEmailAccountList());
      setModalDeleteEmailAccount(false);
      setSelectToDelete([]);
    } else {
      toast.error(emailAccountsDeleteAPI.message);
    }
    dispatch(deleteEmailAccountSuccess([]));
  }, [emailAccountsDeleteAPI]);
  const [modalDeleteEmailAccount, setModalDeleteEmailAccount] = useState(false);
  return (
    <>
      {modalDeleteEmailAccount && (
        <DeleteModal
          show={modalDeleteEmailAccount}
          onCloseClick={() => setModalDeleteEmailAccount(false)}
          onDeleteClick={handleDeleteEmailAccount}
          title={"Delete Email Account"}
          description={"Are you sure you want to delete this email account?"}
        />
      )}
      {modalCreateEditEmailAccount && (
        <CreateEditSettingsEmailAccount
          modal={modalCreateEditEmailAccount}
          setModal={setModalCreateEditEmailAccount}
          toggle={toggleCreateEditEmailAccount}
          isEdit={isEdit}
          updateData={emailAccountsDetailsAPI}
        />
      )}

      <Row>
        <Col lg={12}>
          <Card id="customersList">
            <CardHeader className="border-0">
              <Row className="g-4 align-items-center">
                <Col sm={3}>
                  <div className="search-box">
                    <Input
                      // create search with jobs List Data
                      type="search"
                      className="form-control search"
                      placeholder="Search for..."
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    <button
                      title={"Add New Email Account"}
                      className="btn btn-success"
                      onClick={() => {
                        handleCreateUpdateEmailAccount("create");
                      }}
                    >
                      <i className="ri-add-line align-bottom me-1"></i>
                      Email Account
                    </button>
                  </div>
                </div>
              </Row>
            </CardHeader>
            <CardBody className="pt-0">
              <div>
                {emailAccountsListLoading ? (
                  <LoadingSpinner />
                ) : (
                  <div>
                    {!isEmpty(searchResults) ? (
                      <TableContainer
                        columns={columns}
                        data={searchResults || []}
                        isGlobalFilter={false}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-0"
                        tableClass="align-middle table-wrap"
                        theadClass="text-muted"
                        // handleLeadClick={handleLeadClicks}
                        isLeadsFilter={false}
                      />
                    ) : (
                      <div>
                        {!isEmpty(emailAccountsListAPI) ? (
                          <NoDataContent
                            titleText="No emails found"
                            paragraphText={
                              "Please try with another search keyword."
                            }
                          />
                        ) : (
                          <NoDataContent
                            titleText="No emails found"
                            paragraphText={"Email list is empty."}
                            // todo once create account is ready add button to create new email account
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}
